export const BREAKPOINT_SMALL = '576px';
export const BREAKPOINT_MEDIUM = '768px';
export const BREAKPOINT_LARGE = '992px';
export const BREAKPOINT_XLARGE = '1200px';
